import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { BaseImportModelSectionsPageComponent } from '../../shared/pages/importsections/index';
import { InspectionModelService } from '../../shared/services/index';

@Component({
    templateUrl: '../../shared/pages/importsections/model-sections.component.html',
    standalone: false
})
export class InspectionModelImportModelSectionsPageComponent
  extends BaseImportModelSectionsPageComponent
  implements OnInit
{
  constructor(
    public service: InspectionModelService,
    public inspectionModelService: InspectionModelService,
    public activatedRoute: ActivatedRoute,
    public router: Router,
    location: Location,
    public cdRef: ChangeDetectorRef
  ) {
    super(service, inspectionModelService, activatedRoute, router, location, cdRef);
  }
}
